import { useEffect } from "react";

/**
 * Dynamically sets page-level SEO meta tags.
 * Restores the home page defaults on unmount.
 */
export const useSEO = ({ title, description, canonical }) => {
  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const canonEl = document.querySelector('link[rel="canonical"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDesc = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    const twDesc = document.querySelector('meta[name="twitter:description"]');

    const prevDesc = descEl?.content || "";
    const prevCanon = canonEl?.href || "";
    const prevOgTitle = ogTitle?.content || "";
    const prevOgDesc = ogDesc?.content || "";
    const prevOgUrl = ogUrl?.content || "";
    const prevTwTitle = twTitle?.content || "";
    const prevTwDesc = twDesc?.content || "";

    document.title = title;
    if (descEl) descEl.setAttribute("content", description);
    if (canonEl) canonEl.setAttribute("href", canonical);
    if (ogTitle) ogTitle.setAttribute("content", title);
    if (ogDesc) ogDesc.setAttribute("content", description);
    if (ogUrl) ogUrl.setAttribute("content", canonical);
    if (twTitle) twTitle.setAttribute("content", title);
    if (twDesc) twDesc.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (descEl) descEl.setAttribute("content", prevDesc);
      if (canonEl) canonEl.setAttribute("href", prevCanon);
      if (ogTitle) ogTitle.setAttribute("content", prevOgTitle);
      if (ogDesc) ogDesc.setAttribute("content", prevOgDesc);
      if (ogUrl) ogUrl.setAttribute("content", prevOgUrl);
      if (twTitle) twTitle.setAttribute("content", prevTwTitle);
      if (twDesc) twDesc.setAttribute("content", prevTwDesc);
    };
  }, [title, description, canonical]);
};
